// Combined Bottle and Quantity Image Switcher with Hide/Show Functionality
document.addEventListener('DOMContentLoaded', function() {
  
  // CONFIGURATION: Image identifiers for different combinations
  const imageIdentifiers = {
    'standard': {
      2: 'jb_starterset_hero_NEW',           // Standard Mini
      3: 'Starter_Set_3_boxes',             // Standard Mega  
      5: 'jb_starterset_produkbilder_06_set_uebersicht_5_boxen'  // Standard Maxi
    },
    'premium': {
      2: 'jb_premium_starterset_hero_NEW',  // Premium Mini
      3: 'Premium_Starter_Set_3_boxes',     // Premium Mega
      5: 'jb_premium_starterset_produkbilder_06_set_5_boxen'     // Premium Maxi
    }
  };
  
  // Array to track which images are part of our switching system
  let switchableImageIndices = [];
  
  // Function to get current bottle type
  function getCurrentBottleType() {
    const activeBottleCard = document.querySelector('.JB-bottle-card.active');
    if (activeBottleCard) {
      const bottleValue = activeBottleCard.querySelector('input[type="text"]').value;
      return bottleValue === 'premium-bottle' ? 'premium' : 'standard';
    }
    return 'standard'; // default
  }
  
  // Function to get current quantity
  function getCurrentQuantity() {
    const activeQuantityCard = document.querySelector('.quantity-card.active');
    if (activeQuantityCard) {
      return parseInt(activeQuantityCard.getAttribute('data-quantity'));
    }
    return 3; // default
  }
  
  // Function to identify and store indices of our 6 switchable images
  function identifySwitchableImages() {
    const mediaCarousel = document.querySelector('media-carousel');
    if (!mediaCarousel) return;
    
    const mediaItems = mediaCarousel.querySelectorAll('.product-gallery__media');
    switchableImageIndices = [];
    
    // Find all images that match our identifiers
    Object.values(imageIdentifiers).forEach(bottleType => {
      Object.values(bottleType).forEach(identifier => {
        for (let i = 0; i < mediaItems.length; i++) {
          const img = mediaItems[i].querySelector('img');
          if (img && img.src.includes(identifier)) {
            switchableImageIndices.push(i);
            break;
          }
        }
      });
    });
  }
  
  // Function to hide/show images based on selection
  function updateImageVisibility(selectedIndex) {
    const mediaCarousel = document.querySelector('media-carousel');
    if (!mediaCarousel) return;
    
    const mediaItems = mediaCarousel.querySelectorAll('.product-gallery__media');
    const thumbnails = document.querySelectorAll('.product-gallery__thumbnail');
    
    // Hide all switchable images except the selected one
    switchableImageIndices.forEach(index => {
      if (index < mediaItems.length) {
        const mediaItem = mediaItems[index];
        const thumbnail = thumbnails[index];
        
        if (index === selectedIndex) {
          // Show the selected image
          mediaItem.style.display = '';
          if (thumbnail) thumbnail.style.display = '';
        } else {
          // Hide other switchable images
          mediaItem.style.display = 'none';
          if (thumbnail) thumbnail.style.display = 'none';
        }
      }
    });
    
    // Ensure non-switchable images remain visible
    for (let i = 0; i < mediaItems.length; i++) {
      if (!switchableImageIndices.includes(i)) {
        mediaItems[i].style.display = '';
        if (thumbnails[i]) thumbnails[i].style.display = '';
      }
    }
  }
  
  // Function to switch to the correct image based on current selections
  function switchToCorrectImage() {
    const bottleType = getCurrentBottleType();
    const quantity = getCurrentQuantity();
    const imageIdentifier = imageIdentifiers[bottleType] && imageIdentifiers[bottleType][quantity];
    
    if (!imageIdentifier) return;
    
    // Find the media carousel in the product gallery
    const mediaCarousel = document.querySelector('media-carousel');
    if (!mediaCarousel) return;
    
    // Find all media items (slides) in the carousel
    const mediaItems = mediaCarousel.querySelectorAll('.product-gallery__media');
    
    // Find the matching image slide by checking if src contains our identifier
    for (let i = 0; i < mediaItems.length; i++) {
      const img = mediaItems[i].querySelector('img');
      if (img && img.src.includes(imageIdentifier)) {
        // Update visibility to show only this image from our set
        updateImageVisibility(i);
        
        // Use the carousel's select method to switch to this slide
        mediaCarousel.select(i);
        break;
      }
    }
  }
  
  function setupImageSwitcher() {
    const bottleCards = document.querySelectorAll('.JB-bottle-card');
    const quantityCards = document.querySelectorAll('.quantity-card');
    
    if (bottleCards.length === 0 && quantityCards.length === 0) return false;
    
    // Identify which images are part of our switching system
    identifySwitchableImages();
    
    // Add click handlers to bottle cards
    bottleCards.forEach(card => {
      card.addEventListener('click', function() {
        // Small delay to ensure the active class has been updated
        setTimeout(switchToCorrectImage, 100);
      });
    });
    
    // Add click handlers to quantity cards  
    quantityCards.forEach(card => {
      card.addEventListener('click', function() {
        // Small delay to ensure the active class has been updated
        setTimeout(switchToCorrectImage, 100);
      });
    });
    
    // Set initial image based on current selections
    setTimeout(switchToCorrectImage, 100);
    
    // Add CSS to ensure smooth transitions
    const style = document.createElement('style');
    style.textContent = `
      .product-gallery__media {
        transition: opacity 0.3s ease;
      }
      .product-gallery__media[style*="display: none"] {
        opacity: 0;
      }
      .product-gallery__thumbnail {
        transition: opacity 0.3s ease;
      }
      .product-gallery__thumbnail[style*="display: none"] {
        opacity: 0;
      }
    `;
    document.head.appendChild(style);
    
    return true;
  }
  
  // Try to set up immediately, or wait and retry if elements aren't loaded yet
  if (!setupImageSwitcher()) {
    const checkInterval = setInterval(function() {
      if (setupImageSwitcher()) {
        clearInterval(checkInterval);
      }
    }, 500);
  }
});